
var THF = THF || {};
THF.Interface = THF.Interface || {};
(function ($, jQuery) {
    'use strict';

    THF.Interface.HelpArticleListing = function (options) {

        var defaults = {

            apiConfig: {
                endPoint: '/api/v1/help-hub/topic-list/',
                pageSize:4,
            },
            //article-odd
            currentPage: 0,
            selectors: {
                //Module Parent
                parentElem: '.topic-article-list',
                tileRow: '.tile-container-row',
                oddRow: '.article-odd',
                evenRow: '.article-even',
                btnLoadMore: '.btn-load-more',
                articleTile: '.article-tile-featured',
                pagination: '.pagination',
                paginationProgress: '.pagination-process-bar .inner',
                currentlyShowing: '.pagination .currently-showing',
                totalResults: '.pagination .total-results'
            },

        };

        options = $.extend(true, {}, defaults, options);

        /**********************************
       // Declare DOM elements
       **********************************/
        var parentElem = $(options.selectors.parentElem);
        var $tileRow = $parentElem(options.selectors.tileRow);
        var $oddRow = $parentElem(options.selectors.oddRow);
        var $evenRow = $parentElem(options.selectors.evenRow);
        var $btnLoadMore = $parentElem(options.selectors.btnLoadMore);
        var $paginationProgress = $parentElem(options.selectors.paginationProgress);
        var $currentlyShowing = $parentElem(options.selectors.currentlyShowing);
        var $totalResults = $parentElem(options.selectors.totalResults);

        var catId = parentElem.data('keytopic-id');

        /**********************************
       // State Management
       **********************************/
        function setErrorState(bool) {

            if (bool === true) {
                parentElem.addClass('error-occurred');
                $btnLoadMore.html('Try again?');
            } else {
                parentElem.removeClass('error-occurred');
                $btnLoadMore.html('Show More');
            }
        }




        function updatePagination(loaded, total) {
            var percentageLoaded = (loaded / total * 100) + '%';
            $paginationProgress.css('width', percentageLoaded);
            $currentlyShowing.html(loaded);
            $totalResults.html(total);

            if (loaded === total) {
                $btnLoadMore.addClass('disabled');
            }
        }

        /**********************************
        // Helper function to return a jQuery object, which is a child of 'parentElem'
        **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }

        /**********************************
         // API methods
         **********************************/
        function buildApiUrl(catId, pageSize, pageNumber) {
            // var root = window.location.protocol + '//' + window.location.hostname;
            var apiUrl = options.apiConfig.endPoint + catId + '/page?pageSize=' + pageSize + '&page=' + pageNumber;
            return apiUrl;
        }


        function fetchPage(pageNumber, loadMoreButtonClicked) {
            var apiUrl = buildApiUrl(catId, options.apiConfig.pageSize, pageNumber);
            $.ajax({
                type: 'GET',
                crossDomain: true,
                dataType: 'JSON',
                url: apiUrl,
            })
                .done(function (response) {

                    appendPage(response.topics);
                    setErrorState(false);
                    updatePagination(response.loaded, response.total);
                    initTopicArticleListTracking();

                    //// Track only when 'Load More' button is clicked
                    if (loadMoreButtonClicked) {
                        initLoadMoreTracking(response.loaded, response.total);
                    }

                })

                .fail(function (jqXHR, textStatus, errorThrown) {
                    //setErrorState(true);
                });
        }
        /**********************************
       // Template Generators
       **********************************/
        function getHelpArticleTile(articleObj) {
            var isActive = articleObj.articles.length > 5 ? "loadMore" : "inactive";
            var articleTile =
                ' <div class="field-ktopic-main">\n' +
                ' <div class="title">\n' +
                '<span><svg class="icon" preserveAspectRatio="xMidYMid meet"><use xlink:href="/static/svg/sprite.svg?_cb=4126015790698.343#thf-product-essential-extras"></use></svg></span>\n' +
                '<h3 class="m-0">' + articleObj.name + '\n' +
                '</div>';

            var count = 0;
            articleObj.articles.forEach((article) => {
                var addclass = '';
                if (count > 4) { addclass = "inactive" }
                articleTile += '<div class="form-group field-ktopic ' + addclass + '">\n' +
                    '<a href="' + article.link + '" class="text-transform-none">' + article.name + '</a>\n' +
                    '<span class="last-view ">&nbsp;</span>\n' +
                    '</div>\n';
                count++;
            });

            if (articleObj.articles.length > 5) {
                articleTile += '<span class="viewall pull-right"><a href="javascript:void(0)" class="viewall ' + isActive + '">View All</a></span>\n';

            }

            $(document).on('click', ".loadMore", function () {
                $(this).parent().parent().find('div').removeClass("inactive");
                $(this).hide();
            });

            articleTile += '</div>\n';
            return articleTile;
        }


        /**********************************
         // Rendering
         **********************************/
        function appendPage(pageItems) {
            var x = 0;
            pageItems.forEach(function (obj) {
                if (x % 2 != 0) {
                    var tileMarkup = null;
                    tileMarkup = getHelpArticleTile(obj);
                    $evenRow
                        .append(tileMarkup)
                        .children()
                        .delay(150)
                        .fadeIn(350);
                }
                else {
                    var tileMarkup = null;
                    tileMarkup = getHelpArticleTile(obj);
                    $oddRow
                        .append(tileMarkup)
                        .children()
                        .delay(150)
                        .fadeIn(350);
                }
                x++;
            });

            //Increase the page count
            options.currentPage++;
        }
        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {
            $btnLoadMore.click(function (e) {
                fetchPage(options.currentPage + 1, true);

            });
        }

        /**********************************
       // Load More Button Tracking
       **********************************/
        function initLoadMoreTracking(loaded, total) {
            if (total > 0) {
                var loadedMessage = loaded + ' of ' + total + ' results';
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'showMore',
                    'results': loadedMessage
                });
            }
        }


        /**********************************
        // Tpoic Article List Tracking
        **********************************/
        function initTopicArticleListTracking() {

            // Find topic Tile 
            var $topicTiles = $('.topic-article-list');
            if ($topicTiles.length > 0) {
                $topicTiles.each(function () {
                    var current = $(this);
                    /* Find Service Tile that has not binded to click event */
                    var topicTileButton = current.find('a:not(.bound)');

                    /* Add bound class once the click event is binded to it serviceTileButton */
                    topicTileButton.addClass('bound').click(function (e) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'categoryMainCard',
                            'type': 'Topic',
                            'pagePath': $(this).attr('href')
                        });
                    });
                });
            }

        }



        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                fetchPage(1, false);
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };



})(jQuery, jQuery);



//# sourceMappingURL=help-hub.min.js.map
